import { newSpecPage } from '@stencil/core/testing';
import { SallaBookingField } from '../salla-booking-field';

describe('salla-booking-field', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [SallaBookingField],
      html: `<salla-booking-field></salla-booking-field>`,
    });
    expect(page.root).toEqualHtml(`
      <salla-booking-field>
        <mock:shadow-root>
          <slot></slot>
        </mock:shadow-root>
      </salla-booking-field>
    `);
  });
});
